<template>
  <QuanLyThongTinNguoiDung />
</template>

<script>
import QuanLyThongTinNguoiDung from "@/components/pages/quan-tri-he-thong/nguoi-dung/QuanLyThongTinNguoiDung.vue";
import { setBreadcrumb } from "@/utils/commonUtils";
import { MENU_ROUTE_NAME } from "@/constants/constants";

export default {
  name: "TrangQuanLyThongTinNguoiDung",
  components: {
    QuanLyThongTinNguoiDung
  },
  created() {
    setBreadcrumb(
      `${
        MENU_ROUTE_NAME.QUAN_TRI_HE_THONG.QUAN_LY_THONG_TIN_NGUOI_DUNG
      }`
    );
  }
};
</script>


